<template>
	<v-container style="overflow-y: hidden;">
		<v-dialog title="学员详情页" v-model="hideShow" width="1200px" persistent>
			<v-card >
				<v-card-title>
					<span>学员详情信息</span>
					<v-spacer></v-spacer>
					<v-icon @click="cancel" color="error">mdi-close-circle</v-icon>
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text class="mt-5" >
					<v-tabs background-color="deep-purple accent-1" center-active dark v-model="tab" style="border-radius: 5px 5px 0 0;" active-class="child_active" @change="tabChanged">
						<v-tabs-slider color="deep-purple accent-4"></v-tabs-slider>
						<v-tab>学员信息</v-tab>
						<v-tab>在读班级</v-tab>
						<v-tab>学员课表</v-tab>
						<v-tab>学费账户明细</v-tab>
						<v-tab>课时账户明细</v-tab>
					</v-tabs>
					<v-tabs-items v-model="tab">
						<v-tab-item>
							<v-card class="elevation-4 mb-1" height="660" style="border: solid #eee 1px; overflow-y: auto;">
								<v-card-text class="pl-10">
									<v-row class="mt-3"  v-if="student" >
										<v-col cols="4" class="d-flex flex-column">
											<!-- 头像区 -->
											<div class="d-flex">
												<div>
													<v-avatar size="80" style="cursor: pointer;">
														<v-img v-if="student.avatar" :src="imgPrev + student.avatar" width="80" height="80" @click="showImageViewer(student.avatar)"></v-img>
													</v-avatar>
													<div style="width:100px" class="mt-2">
														<v-btn color="info" small :disabled="student.status!='1'" @click="updateStudentShow=true">修改资料</v-btn>	
													</div>
												</div>
												<div class="d-flex flex-column mt-8">
													<div>
														<span>{{student.studentName}} [学号:{{student.studentNo}}]</span>
													</div>
													<div class="mt-2">
														<v-chip small :color="genderColor(student.gender)">{{ genderName(student.gender) }}</v-chip>
													</div>
												</div>
											</div>
											<!-- 年龄 生日 -->
											<div class="mt-5">
												<span>生日：{{student.birthday}}</span>
												<span class="ml-4">年龄：{{student.age}}</span>
											</div>
											<!-- 联系人 -->
											<div class="mt-5">
												<span>联系人关系：</span>
												<span>{{student.contactorCall}}</span>
												<span class="ml-3">电话：</span>
												<span>{{student.contactorMobile}}</span>
											</div>
											<!-- 生源类型 -->
											<div class="mt-3">
												<span>生源类型：</span>
												<span>{{student.sourceName}}</span>
											</div>
											<div class="mt-3">
												<span>入学时间：{{student.createAt}}</span>
											</div>
											<div class="mt-3">
												<span class="mt-3">状态：</span>
												<span>{{ studentStatusName(student.status) }}</span>
												<v-btn v-if="student.status=='1'" color="info" @click="closeStudent" class="ml-3 mt-n1" small>结业</v-btn>
												<v-btn v-if="student.status=='2'" color="info" @click="openStudent" class="ml-3 mt-n1" small>复学</v-btn>
											</div>
											<!-- 家长账号： -->
											<div class="mt-3">
												<span>家长系统账号：</span>
												<span v-if="student.appUserMobile">{{student.appUserMobile}}</span>
												<v-btn v-if="student.appUserMobile" color="info" @click="unbindParentMobile" class="ml-3" small>解绑</v-btn>
												<span v-if="!student.appUserMobile" style="color: red;">未绑定</span>
												<v-btn v-if="!student.appUserMobile" color="info" @click="showBindParentMobile" class="ml-3" small>去开通</v-btn>
											</div>
											<div class="mt-3">
												<span>家长账号激活：</span>
												<span v-if="student.appUserIsSignIn=='0'" style="color: red;">未激活</span>
												<span v-if="student.appUserIsSignIn=='1'">已激活</span>
											</div>
											<div class="mt-3">	
												<span>家长绑定微信：</span>
												<span v-if="student.appUserBindWx=='0'" style="color: red;">未绑定</span>
												<span v-if="student.appUserBindWx=='1'">已绑定</span>
											</div>
											<div class="mt-3">
												<span>身份证号：</span>
												<span>{{student.idCardNo}}</span>
											</div>
											<div class="mt-3">
												<span>就读学校：</span>
												<span>{{student.fromSchoolName}}</span>
											</div>
											<div class="mt-3">
												<span>居住片区：</span>
												<span>{{student.fromRegionName}}</span>
											</div>
											<div class="mt-3">
												<span>家庭住址：</span>
												<span>{{student.homeAddress}}</span>
											</div>
											<div class="mt-3">
												<span>最新状况：</span>
												<span>{{student.situationDesc}}</span>
											</div>
											<div class="mt-3">
												<template v-if="student.situationDesc">
													<span style="color:#2196F3; cursor: pointer;font-weight: 600;" class="" @click="showSituationList">
														查看更多学习状况 >
													</span>
												</template>
											</div>
										</v-col>
										<v-col cols="8" class="d-flex flex-column pl-5">
											<!-- 学员账户 -->
											<div class="d-flex flex-column mt-8 mr-10">
												<div class="d-flex">
													<span class="text-h6">账户余额</span>
													<v-spacer></v-spacer>
													<v-btn color="info" @click="rechargeShow=true" class="mb-2">缴费</v-btn>
												</div>
												<div style="background-color: #eeeeee; height: 2px;width: 100%"></div>
											</div>
											<div v-for="group in accountGroups" :key="group.key" class="ml-2" :class="{ 'zero-hour-account-group': group.key === 'zero' }">
												<div v-if="group.key === 'zero'" class="text-subtitle-1 grey--text text--darken-1">已完结课程（{{group.items.length}}）</div>
												<div class="d-flex flex-wrap mt-3">
													<div v-for="(item,index) in group.items" :key="item.accountType + '-' + (item.accountId || index)" class="d-flex mt-3 mr-5">
														<div v-if="item.accountType=='CASH'" style="height: 100px; width: 10px; border-radius: 10px 0 0 10px; background-color: #4DD0E1;"></div>
														<div v-if="item.accountType=='TIMES'" style="height: 100px; width: 10px; border-radius: 10px 0 0 10px; background-color: #B388FF;"></div>
														<div class="d-flex flex-column pl-3" style="background: #F5F5F5; width: 300px; border-radius: 0 10px 10px 0;">
															<div class="mt-2 d-flex justify-space-between">
																<span style="font-size: 16px;">{{item.accountType=='CASH'?'金额账户':item.courseName}}</span>
																<!-- <span class="mr-2 red--text">手工划课</span> -->
															</div>

															<div class="mt-3">
																<span style="font-size: 23px; font-weight: 400; color:#651FFF">{{item.balanceAmount}}</span>
																<span class="ml-1 mt-1">{{item.accountType=='CASH'?'元':'课时'}}</span>
																<template v-if="item.expireDate">
																	<span style="margin-left: 10px;">(有效期:{{item.expireDate}})</span>
																</template>
															</div>
															<div class="mt-0">
																<span>{{item.accountType=='CASH'?'总金额':'总课时'}}</span>
																<span class="ml-1">{{item.totalAmount}}</span>
																<span class="ml-1">{{item.accountType=='CASH'?'元':'课时'}}</span>
																<span class="ml-5">已用</span>
																<span class="ml-1">{{item.usedAmount}}</span>
																<span class="ml-1">{{item.accountType=='CASH'?'元':'课时'}}</span>
															</div>
														</div>
													</div>
												</div>
											</div>
											
										</v-col>
										
									</v-row>

								</v-card-text>
								
							</v-card>
						</v-tab-item>
						
						<!-- 在读班级 -->
						<v-tab-item>
							<v-card class="elevation-4 mb-1" height="660" style="border: solid #eee 1px;">
								<v-card-title>
									
									<v-btn color="info" @click="joinClassShow=true">学员分班</v-btn>
									<v-spacer></v-spacer>
								</v-card-title>
								<v-card-text class="ml-10 mt-n3">
									<div class="d-flex flex-wrap mt-3" >
										<v-card v-for="(item,index) in classList"  :key="index" class="d-flex mt-5 mr-6 elevation-4" color="#f5f5f5">
											<div v-if="item.consumeType=='2'" style="height: 200px; width: 12px; border-radius: 5px 0 0 5px; background-color: #4DD0E1;"></div>
											<div v-if="item.consumeType=='1'" style="height: 200px; width: 12px; border-radius: 5px 0 0 5px; background-color: #B388FF;"></div>
											<div class="d-flex flex-column pl-6" style="background: #F5F5F5; width: 490px; border-radius: 0 10px 10px 0;">
												<div class="mt-6 d-flex">
													<span style="font-size: 20px; font-weight: 500;">{{item.className}}</span>
													<span style="font-size: 14px;" class="ml-3">[{{item.consumeType=='2'?'按金额扣费':'按课时扣费'}}]</span>
												</div>
												
												<div class="mt-3 d-flex">
													<span>课程:{{item.courseName}}</span>
													<span class="ml-3">老师:{{item.teacherName}}</span>
													<div v-if="item.isViewTeacherPerformancePrice=='1'" class="ml-2">
														<span style="color: red;">分成计算价格:</span>
														<span class="ml-1" v-if="item.teacherBonusPrice">{{item.teacherBonusPrice}}元/课时</span>
														<span v-else>-</span>
														<v-btn x-small @click="showUpdateBonusPriceCom(item)" class="ml-2 mt-n1" color="info">设置</v-btn>
													</div>
												</div>
												<div class="mt-2">
													<span>学员:{{item.inClassStudentCount}}人</span>
													<span class="ml-5">总课程数:{{item.totalRecordCount}}</span>
													<span class="ml-5">已上课程数:{{item.approvedRecordCount}}</span>
												</div>
												<div  class="d-flex mt-2">
													<div>
														<span>进班日期:</span>
														<span class="ml-1">{{item.joinDate}}</span>
														<v-btn x-small @click="showUpdateJoinDateCom(item)" color="info" class="ml-2 mt-n1">修改</v-btn>
													</div>
													<div v-if="item.consumeType=='2'" class="ml-3">
														<span>学员消课价格:</span>
														<span class="ml-1">{{item.classPrice}}</span>
														<span class="ml-1">元</span>
														<v-btn x-small @click="showUpdateClassPriceCom(item)" class="ml-2 mt-n1" color="info">修改</v-btn>
													</div>
													
												</div>
												
												
												<div class="d-flex flex-wrap pt-2">
													<!-- <v-chip v-for="(plan,idx) in item.classTimePlanList" :key="idx" color="error" class="mr-1">
														<span>{{plan.weekName}}</span>
														<span class="ml-1">{{plan.timeFrom}}-{{plan.timeTo}}</span>
													</v-chip> -->
													<div v-for="(plan,idx) in item.classTimePlanList" :key="idx" class="mr-2"
														style="width: 115px; border-bottom: solid #B388FF 2px; border-radius: 5px; text-align: center;">
														<span>{{plan.weekName}}</span>
														<span class="ml-1">{{plan.timeFrom}}-{{plan.timeTo}}</span>
													</div>
												</div>
												
											</div>
										</v-card>
									</div>
								</v-card-text>
								
							</v-card>
						</v-tab-item>
						<!-- 学员的排课明细 -->
						<v-tab-item>
							<v-card class="elevation-4 mb-1" height="660" style="border: solid #eee 1px;overflow-y: auto;">
								<v-card-text class="mt-n1">
									<studentRecordList :studentId="studentId" :classItems="allClassItems" :refreshData="recordListRefreshTime"></studentRecordList>
								</v-card-text>	
							</v-card>
						</v-tab-item>
						<!-- 金额账户流水明细 -->
						<v-tab-item>
							<v-card class="elevation-4 mb-1" height="660" style="border: solid #eee 1px;">
								<v-card-text>
									<v-data-table :headers="cashJournal.headers" :items="cashJournal.list" :loading="cashJournal.query.loading" class="elevation-1"
										disable-pagination hide-default-footer item-key="id" no-data-text="暂无数据" loading-text="正在加载,请稍候......">
										<template v-slot:top>
											<v-row dense class="mt-n1 mb-n6">
												<v-col cols="3">
													<v-menu ref="menu1" v-model="cashJournal.menu1" :close-on-content-click="false"
													    transition="scale-transition" offset-y
														min-width="auto">
														<template v-slot:activator="{ on, attrs }">
															<v-text-field v-model="cashJournal.query.start" label="创建开始日期" readonly v-bind="attrs" v-on="on"
																dense clearable outlined></v-text-field>
														</template>
														<v-date-picker v-model="cashJournal.query.start"  @input="cashJournal.menu1=false" no-title scrollable locale="zh-cn">
														</v-date-picker>
													</v-menu>
												</v-col>
												<v-col cols="3">
													<v-menu ref="menu2" v-model="cashJournal.menu2" :close-on-content-click="false"
														 transition="scale-transition" offset-y min-width="auto">
														<template v-slot:activator="{ on, attrs }">
															<v-text-field v-model="cashJournal.query.end" label="创建结束日期" readonly v-bind="attrs" v-on="on"
																dense clearable outlined></v-text-field>
														</template>
														<v-date-picker v-model="cashJournal.query.end" @input="cashJournal.menu2=false" no-title scrollable locale="zh-cn">
														</v-date-picker>
													</v-menu>
												</v-col>
												<v-col cols="2">
													<v-select :items="cashJournal.inOutItems"  item-text="text" item-value="id" dense label="增加/减少"
														outlined v-model="cashJournal.query.inOut" />
												</v-col>
												<v-col cols="2" class="mt-1">
													<v-btn @click="cashQueryClicked" color="primary" small>查询</v-btn>
												</v-col>
											</v-row>
											<v-divider></v-divider>
										</template>
										<template v-slot:item.status="{item}">
											<v-chip small :color="cashJournalStatusColor(item.status)">{{ cashJournalStatusName(item.status) }}
											</v-chip>
										</template>
										<template v-slot:item.inOut="{item}">
											<span v-if="item.inOut=='1'" style="color: #E65100;">{{ cashJournalInOutName(item.inOut) }}</span>
											<span v-if="item.inOut=='2'">{{ cashJournalInOutName(item.inOut) }}</span>
										</template>
										<template v-slot:item.amount="{item}">
											<span v-if="item.inOut=='1'" style="color: #E65100;">+{{ item.amount }}</span>
											<span v-if="item.inOut=='2'">-{{ item.amount }}</span>
										</template>
									
									</v-data-table>
									<div class="pt-2">
										<v-row dense>
											<v-col cols="1" >
												<v-select :items="[10, 20, 50, 100]" @change="cashJournalSizeChanged" dense disabled hide-details label="每页数量"
													outlined v-model="cashJournal.query.size" />
											</v-col>
											<v-col cols="1" class="mt-2">
												<span>共{{cashJournal.total}}项</span>
											</v-col>
											<v-col cols="9"   v-if="Math.ceil(cashJournal.total/cashJournal.query.size)>0">
												<v-pagination :length="Math.ceil(cashJournal.total/cashJournal.query.size)" @input="cashJournalPageChanged"
													total-visible="5" v-model="cashJournal.query.page" />
											</v-col>
										</v-row>
									</div>
								</v-card-text>
							</v-card>
						</v-tab-item>
						
						<!-- 课时账户流水明细 -->
						<v-tab-item>
							<v-card class="elevation-4 mb-1" height="660" style="border: solid #eee 1px;">
								<v-card-text>
									<v-data-table :headers="courseJournal.headers" :items="courseJournal.list" :loading="courseJournal.query.loading" class="elevation-1"
										disable-pagination hide-default-footer item-key="id" loading-text="正在加载,请稍候......">
										<template v-slot:top>
											<v-row dense class="mt-n1 mb-n8">
												<v-col cols="3">
													<v-select :items="courseItems"  item-text="courseName" item-value="courseId" dense label="课程"
														outlined v-model="courseJournal.query.courseId" />
												</v-col>
												<v-col cols="3">
													<v-menu ref="menu1" v-model="courseJournal.menu1" :close-on-content-click="false"
													    transition="scale-transition" offset-y
														min-width="auto">
														<template v-slot:activator="{ on, attrs }">
															<v-text-field v-model="courseJournal.query.start" label="创建开始日期" readonly v-bind="attrs" v-on="on"
																dense clearable outlined></v-text-field>
														</template>
														<v-date-picker v-model="courseJournal.query.start"  @input="courseJournal.menu1=false" no-title scrollable locale="zh-cn">
														</v-date-picker>
													</v-menu>
												</v-col>
												<v-col cols="3">
													<v-menu ref="menu2" v-model="courseJournal.menu2" :close-on-content-click="false"
														 transition="scale-transition" offset-y min-width="auto">
														<template v-slot:activator="{ on, attrs }">
															<v-text-field v-model="courseJournal.query.end" label="创建结束日期" readonly v-bind="attrs" v-on="on"
																dense clearable outlined></v-text-field>
														</template>
														<v-date-picker v-model="courseJournal.query.end" @input="courseJournal.menu2=false" no-title scrollable locale="zh-cn">
														</v-date-picker>
													</v-menu>
												</v-col>
												<v-col cols="2">
													<v-select :items="courseJournal.inOutItems"  item-text="text" item-value="id" dense label="增加/减少"
														outlined v-model="courseJournal.query.inOut" />
												</v-col>
												<v-col cols="1" class="mt-1">
													<v-btn @click="courseQueryClicked" color="primary" small>查询</v-btn>
												</v-col>
											</v-row>
										</template>
										<template v-slot:item.inOut="{item}">
											<span v-if="item.inOut=='1'" style="color: #E65100;">{{ cashJournalInOutName(item.inOut) }}</span>
											<span v-if="item.inOut=='2'">{{ cashJournalInOutName(item.inOut) }}</span>
										</template>
										
										<template v-slot:item.amount="{item}">
											<span v-if="item.inOut=='1'" style="color: #E65100;">+{{ item.amount }}</span>
											<span v-if="item.inOut=='2'">-{{ item.amount }}</span>
										</template>
									
									</v-data-table>
									<div class="pt-2">
										<v-row dense>
											<v-col cols="1" >
												<v-select :items="[10, 20, 50, 100]" @change="courseJournalSizeChanged" dense disabled hide-details label="每页数量"
													outlined v-model="courseJournal.query.size" />
											</v-col>
											<v-col cols="1" class="mt-2">
												<span>共{{courseJournal.total}}项</span>
											</v-col>
											<v-col cols="9"   v-if="Math.ceil(courseJournal.total/courseJournal.query.size)>0">
												<v-pagination :length="Math.ceil(courseJournal.total/courseJournal.query.size)" @input="courseJournalPageChanged"
													total-visible="5" v-model="courseJournal.query.page" />
											</v-col>
										</v-row>
									</div>
								</v-card-text>
							</v-card>
						</v-tab-item>
					</v-tabs-items>
				</v-card-text>
			</v-card>
			
		</v-dialog>
		<!-- 学员缴费组件 -->
		<studentRecharge :show="rechargeShow" :student="student" @cancel="rechargeShow=false" @success="rechareSuccess"></studentRecharge>
		<!-- 修改班级价格组件 -->
		<updateStudentPrice :show="updatePriceShow" :classStudent="classStudent" @cancel="updatePriceShow=false" @success="updatePriceSuccess"></updateStudentPrice>
		<!-- 学员加入班级 -->
		<studentJoinClass :show="joinClassShow" :student="student" @cancel="joinClassShow=false" @success="joinClassSuccess"></studentJoinClass>
		<!-- 修改学员资料 -->
		<updateStudent :show="updateStudentShow"  :student="student" @cancel="updateStudentShow=false" @success="updateStudentSuccess"></updateStudent>
		<!-- 绑定家长手机号组件 -->
		<bindParentMobile :show="bindParent.show" :studentId="bindParent.studentId" :studentName="bindParent.studentName" 
			@cancel="bindParent.show=false" @success="bindParentSuccess"></bindParentMobile>
		<!-- 修改进班日期组件 -->
		<updateStudentJoinDate :show="updateJoinDate.show" :classStudent="updateJoinDate.classStudent" @cancel="updateJoinDate.show=false" 
			@success="updateJoinDateSuccess"></updateStudentJoinDate>
			
		<!-- 修改提成计算价格组件 -->
		<updateStudentTeacherBonusPrice :show="updateBonusPriceShow" :classStudent="classStudent" @cancel="updateBonusPriceShow=false" @success="updateBonusPriceSuccess"></updateStudentTeacherBonusPrice>
		<!-- 图片预览 -->
		<imageViewer :show="imageViewerDialog.show" :imgSrc="imageViewerDialog.imgSrc" imgWidth="400" imgHeight="400" @cancel="imageViewerDialog.show=false"></imageViewer>
		<!-- 学员状况列表 -->
		<studentSituationList :show="situationListDialog.show" :studentId="situationListDialog.studentId" @cancel="situationListDialog.show=false"></studentSituationList>
	</v-container>
</template>

<script>
	import studentRecharge from "./student_recharge.vue"
	import updateStudentPrice from "./update_student_price.vue"
	import studentJoinClass from "./student_join_class.vue"
	import updateStudent from "./update_student.vue"
	import bindParentMobile from "./bind_parent_mobile.vue"
	import studentRecordList from "./student_record_list.vue"
	import updateStudentJoinDate from "./update_student_join_date.vue"
	import updateStudentTeacherBonusPrice from "./update_student_teacher_bonus_price.vue"
	import imageViewer from "./image_viewer.vue"
	import studentSituationList from "./student_situation_list.vue"
	export default {
		name: "student-detail",
		components:{
			studentRecharge,
			updateStudentPrice,
			studentJoinClass,
			updateStudent,
			bindParentMobile,
			studentRecordList,
			updateStudentJoinDate,
			updateStudentTeacherBonusPrice,
			imageViewer,
			studentSituationList
		},
		props: {
			//显示/隐藏。
			show: {
				type: Boolean,
				default: false
			},
			
			studentId:{
				type:String,
				default:""
			}

		},
		watch: {
			show(newVal, oldVal) {
				console.log("newVal", newVal);
				this.hideShow = newVal;
				if(newVal){
					this.tab = 0;
					this.student = null;
					// 清空cashjournal的数据
					this.cashJournal.query.page= 1;
					this.cashJournal.query.size = 10;
					this.cashJournal.total = 0;
					this.cashJournal.list = [];
					
					// 清空coursejournal的数据
					this.courseJournal.query.courseId = "";
					this.courseJournal.query.page= 1;
					this.courseJournal.query.size = 10;
					this.courseJournal.total = 0;
					this.courseJournal.list = [];
					this.courseJournal.myCourseItems = [];
					
				
					this.getStudentDetail();
					this.getAccountList();
					this.getClassList();
					
				
				}
			},
			
		},
		data() {
			return {
				imgPrev:"https://photo.youkeya.cn/",
				tab:null,
				hideShow: this.show,
				student:null,
				rechargeShow:false, // 控制学员缴费组件的显示
				updatePriceShow:false, // 控制修改学员扣费价格的组件显示
				joinClassShow:false, //控制加入班级组件的显示
				updateStudentShow:false,//控制修改班级组件的显示
				updateBonusPriceShow:false, //控制修改教师提成价格的显示
				parentMobile:"", //家长账号
				accountList:[],// 账户信息
				classList:[],// 班级列表
				allClassItems:[], // 学员的所有就读班级
				courseItems:[], // 课时账户的课程列表
				recordListRefreshTime:"", // 学员课表刷新标记 点击tab就刷新
				bindParent:{
					show:false,
					studentId:"",
					studentName:""
				},
				updateJoinDate:{
					show:false,
					classStudent:null
				},
				imageViewerDialog:{
					show:false,
					imgSrc:"",
				},
				situationListDialog:{
					show:false,
					studentId:"",
				},
				cashJournal:{
					// 学费明细
					total:0,
					menu1:false,
					menu2:false,
					query:{
						loading: false,
						page: 1,
						size: 10,
						start: "",
						end: "",
						inOut:""
					},
					inOutItems:[{id:"",text:"全部"},{id:"1",text:"增加"},{id:"2",text:"减少"}],
					headers:[
						{
							text: '业务时间',
							value: 'createAt',
							sortable: false,
							width:"170"
						},
						{
							text: '增/减',
							value: 'inOut',
							sortable: false,
							width:"70"
						},
						{
							text: '业务类型',
							value: 'bizType',
							sortable: false,
							width:"130"
						},
						{
							text: '业务前',
							value: 'lastAmount',
							sortable: false
						},
						{
							text: '本次学费',
							value: 'amount',
							sortable: false
						},
						{
							text: '业务后',
							value: 'balanceAmount',
							sortable: false
						},
						{
							text: '备注',
							value: 'memo',
							sortable: false
						},
					],
					list:[]
				},
				courseJournal:{
					// 课时明细
					total:0,
					menu1:false,
					menu2:false,
					query:{
						loading: false,
						page: 1,
						size: 10,
						courseId:"",
						start: "",
						end: "",
						inOut:""
					},
					inOutItems:[{id:"",text:"全部"},{id:"1",text:"增加"},{id:"2",text:"减少"}],
					headers:[
						{
							text: '课程名称',
							value: 'courseName',
							sortable: false,
							width:"150"
						},
						{
							text: '业务时间',
							value: 'createAt',
							sortable: false,
							width:"180"
						},
						{
							text: '增/减',
							value: 'inOut',
							sortable: false,
							width:"70"
						},
						{
							text: '业务类型',
							value: 'bizType',
							sortable: false,
							width:"120"
						},
						{
							text: '业务前',
							value: 'lastAmount',
							sortable: false,
							width:"70"
						},
						{
							text: '本次课时',
							value: 'amount',
							sortable: false,
							width:"90"
						},
						{
							text: '业务后',
							value: 'balanceAmount',
							sortable: false,
							width:"80"
						},
						{
							text: '备注',
							value: 'memo',
							sortable: false
						},
					],
					list:[]
				},
				classStudent:{},
			}
		},
		mounted() {
			//this.getShopListForSelect();
			console.log("student detail mounted");
		},
		computed: {
			accountGroups() {
				const otherAccounts = [];
				const zeroHourAccounts = [];
				this.accountList.forEach(item => {
					const balance = item.balanceAmount;
					const isZeroHourAccount = item.accountType === 'TIMES' && balance != null && String(balance).trim() !== '' && Number(balance) === 0;
					(isZeroHourAccount ? zeroHourAccounts : otherAccounts).push(item);
				});
				return [
					{ key: 'other', items: otherAccounts },
					{ key: 'zero', items: zeroHourAccounts },
				].filter(group => group.items.length > 0);
			},
		},
		methods: {
			genderName(state) {
			
				let stName = "未知";
				if (state === "1") {
					stName = "男生";
				} else if (state === "0") {
					stName = "女生";
				}
				return stName;
			},
			genderColor(state) {
				let color = "";
				if (state === "1") {
					color = "blue lighten-4";
				} else if (state === "0") {
					color = "pink lighten-4";
				}
			
				return color;
			},
			studentStatusName(state) {
			
				let stName = "未知";
				if (state === "1") {
					stName = "在读";
				} else if (state === "0") {
					stName = "冻结";
				} else if (state === "2") {
					stName = "结业";
				} else if (state === "3") {
					stName = "意向";
				} else if (state === "4") {
					stName = "无意向";
				}
				return stName;
			},
			studentStatusColor(state) {
				let color = "";
				if (state === "1") {
					color = "success";
				} else if (state === "0") {
					color = "error";
				} else if (state === "2") {
					color = "primary";
				} else if (state === "3") {
					color = "warning";
				} else if (state === "4") {
					color = "error";
				}
			
				return color;
			},
			tabChanged(e){
				console.log(e);
				if(e == 2){
					// 学员课表
					// 设置刷新
					let randNum = Math.random();
					this.recordListRefreshTime =  randNum.toString();
					
				}else if(e ==3 ) {
					// 现金账户明细
					this.cashJournal.query.page = 1;
					this.getCashJournalList();
				}else if(e==4){
					// 课程账户明细
					this.courseJournal.query.page = 1;
					this.getCourseJournalList();
				}
			},
			cancel() {
				this.$emit("cancel", "");
			},
			showImageViewer(imgSrc){
				this.imageViewerDialog.imgSrc = imgSrc;
				console.log(imgSrc);
				this.imageViewerDialog.show=true;
			},
			showSituationList(){
				// 显示全部状况
				this.situationListDialog.studentId = this.studentId;
				this.situationListDialog.show =true;
				
			},
			getStudentDetail(){
				const that = this;
				let url = `/edu/student/detail/${this.studentId}`;
				
				this.axios.get(url).then(response => {
				
					if (response.data["code"] === 200) {
						
						console.log(">>>>>>>>>获取学员基本信息 start>>>>>>>>>")
						
						console.log("url:",url);
						console.log("res:",response.data);
						
						console.log(">>>>>>>>>获取学员基本信息 end>>>>>>>>>")
						
						that.student = response.data["data"] ? response.data["data"] : [];
						
						
						return
					}
				
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			getAccountList(){
				console.log("getAccountList");
				
				const that = this;
				let url = `/financial/student/all/account/list/${this.studentId}`;
				
				this.axios.get(url).then(response => {
				
					if (response.data["code"] === 200) {
						
						console.log(">>>>>>>>>获取学员所有账户信息 start>>>>>>>>>")
						
						console.log("url:",url);
						console.log("res:",response.data);
						
						console.log(">>>>>>>>>获取学员所有账户信息 end>>>>>>>>>")
						
						that.accountList = response.data["data"] ? response.data["data"] : [];
						
						// 处理课程账户
						that.courseItems = [];
						that.accountList.forEach((item,index)=>{
							if (item.accountType=='TIMES'){
								let c = {courseId:item.courseId,courseName:item.courseName};
								that.courseItems.push(c);
							}
						});
						
						return
					}
				
					that.$noty.error("获取失败：" + response.data["message"]);
				})
				
				
			},
			getClassList(){
				console.log("getClassList");
				
				const that = this;
				let url = `/edu/student/all/class/list/${this.studentId}`;
				
				this.axios.get(url).then(response => {
				
					if (response.data["code"] === 200) {
						
						console.log(">>>>>>>>>获取学员所有班级信息 start>>>>>>>>>")
						
						console.log("res:",response.data);
						
						console.log(">>>>>>>>>获取学员所有班级信息 end>>>>>>>>>")
						
						that.classList = response.data["data"] ? response.data["data"] : [];
						
						
						// 处理学员就读的全部班级
						that.allClassItems = [];
						that.classList.forEach((item,index)=>{
							let c = {id:item.classId,className:item.className};
							that.allClassItems.push(c);
						});
						
						return
					}
				
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			cashQueryClicked(){
				this.cashJournal.query.page = 1;
				this.getCashJournalList();
			},
			cashJournalSizeChanged(size) {
				this.cashJournal.query.size = size;
				this.cashJournal.query.page = 1;
				this.getCashJournalList();
			},
			cashJournalPageChanged(page) {
				this.cashJournal.query.page = page;
				this.getCashJournalList();
			},
			getCashJournalList(){
				const that = this;
				this.cashJournal.query.loading = true;
				
				
				let url = `/financial/student/cash/journal/list/page/${that.cashJournal.query.page - 1}/size/${that.cashJournal.query.size}?v=1`;
				url += "&studentNo=" + this.student.studentNo;
				
				if (this.cashJournal.query.start) {
					url += "&start=" + this.cashJournal.query.start;
				}
				if (this.cashJournal.query.end) {
					url += "&end=" + this.cashJournal.query.end;
				}
				if (this.cashJournal.query.inOut) {
					url += "&inOut=" + this.cashJournal.query.inOut;
				}

				this.axios.get(url).then(response => {
					
					if (response.data["code"] === 200) {
						
						that.cashJournal.list = response.data["data"]["list"] ? response.data["data"]["list"] : [];
						that.cashJournal.total = response.data["data"]["count"];
				
						that.cashJournal.query.loading = false;
						return
					}
					that.cashJournal.query.loading = false;
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			cashJournalInOutName(state) {
			
				let stName = "未知";
				if (state === "1") {
					stName = "增加";
				} else if (state === "2") {
					stName = "减少";
				}
				return stName;
			},
			cashJournalInOutColor(state) {
				let color = "";
				if (state === "1") {
					color = "success";
				} else if (state === "2") {
					color = "error";
				}
				return color;
			},
			cashJournalStatusName(state) {
			
				let stName = "未知";
				if (state === "1") {
					stName = "正常";
				} else if (state === "0") {
					stName = "冻结";
				}
				return stName;
			},
			cashJournalStatusColor(state) {
				let color = "";
				if (state === "1") {
					color = "success";
				} else if (state === "0") {
					color = "error";
				}
			
				return color;
			},
			courseQueryClicked(){
				this.courseJournal.query.page = 1;
				this.getCourseJournalList();
			},
			courseJournalSizeChanged(size) {
				this.courseJournal.query.size = size;
				this.courseJournal.query.page = 1;
				this.getCourseJournalList();
			},
			courseJournalPageChanged(page) {
				this.courseJournal.query.page = page;
				this.getCourseJournalList();
			},
			getCourseJournalList(){
				
				const that = this;
				this.courseJournal.query.loading = true;
				
				
				let url = `/financial/student/account/journal/list/page/${that.courseJournal.query.page - 1}/size/${that.courseJournal.query.size}?v=1`;
				url += "&studentNo=" + this.student.studentNo;
				if (this.courseJournal.query.courseId) {
					url += "&courseId=" + this.courseJournal.query.courseId;
				}
				
				if (this.courseJournal.query.start) {
					url += "&start=" + this.courseJournal.query.start;
				}
				if (this.courseJournal.query.end) {
					url += "&end=" + this.courseJournal.query.end;
				}
				if (this.courseJournal.query.inOut) {
					url += "&inOut=" + this.courseJournal.query.inOut;
				}
			
				this.axios.get(url).then(response => {
					
					if (response.data["code"] === 200) {
						
						that.courseJournal.list = response.data["data"]["list"] ? response.data["data"]["list"] : [];
						that.courseJournal.total = response.data["data"]["count"];
				
						that.courseJournal.query.loading = false;
						return
					}
					that.courseJournal.query.loading = false;
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			rechareSuccess(){
				// 学员缴费成功
				this.rechargeShow = false;
				this.getAccountList();
			},
			showUpdateClassPriceCom(item){
				this.updatePriceShow = true;
				this.classStudent = item;
			},
			showUpdateBonusPriceCom(item){
				this.updateBonusPriceShow = true;
				this.classStudent = item;
			},
			updatePriceSuccess(){
				//修改价格成功
				this.updatePriceShow = false;
				this.getClassList();
			},
			updateBonusPriceSuccess(){
				this.updateBonusPriceShow = false;
				this.getClassList();
			},
			showUpdateJoinDateCom(item){
				// 显示修改入班日期
				this.updateJoinDate.show = true;
				this.updateJoinDate.classStudent = item;
			},
			updateJoinDateSuccess(){
				//修改日期成功
				this.updateJoinDate.show = false;
				this.getClassList();
			},
			joinClassSuccess(){
				//加入班级成功
				this.joinClassShow = false;
				this.getClassList();
			},
			updateStudentSuccess(){
				this.updateStudentShow = false;
				this.getStudentDetail();
			},
			showBindParentMobile(){
				this.bindParent.studentId = this.student.id;
				this.bindParent.studentName = this.student.studentName;
				this.bindParent.show = true;
			},
			bindParentSuccess(){
				this.bindParent.show=false;
				this.getStudentDetail();
			},
			unbindParentMobile(){
				// 解绑家长手机号
				// api
				const that = this;
				let url = `/edu/student/app/user/mobile/unbind/${this.studentId}`;
				
				
				this.axios.post(url).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("解绑成功");
							this.getStudentDetail();
				
							return;
						} else {
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.$noty.error('网络请求失败');
					}
				
				});
			},
			closeStudent() {
				// 设置学员为毕业
				const studentId = this.studentId;
				// api
				const that = this;
				let url = `/edu/student/close/${studentId}`;
			
				this.axios.post(url, {}).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("操作成功");
							that.getStudentDetail();
			
							return;
						} else {
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.$noty.error('网络请求失败');
					}
			
				});
			
			},
			openStudent(){
				// 结业学员复学
				const studentId = this.studentId;
				// api
				const that = this;
				let url = `/edu/student/open/${studentId}`;
				
				this.axios.post(url, {}).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("操作成功");
							that.getStudentDetail();
				
							return;
						} else {
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.$noty.error('网络请求失败');
					}
				
				});
			},
		}
	}
</script>

<style lang="scss" scoped>
	.zero-hour-account-group {
		margin-top: 24px;
		padding-top: 12px;
		border-top: 1px solid #e0e0e0;
	}
	.child_active{
		background-color:#651FFF;
		border-radius: 5px 5px 0 0;	
		&:hover  {
			
		}
	}
</style>
